import { AppAlert, AppButton, AppLoadingSpinner } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import OneLoginLogo from '@frontend/public/onelogin_mark_white.svg'
import { useState } from 'react'
import { useAutoLogin } from './-hooks/useAutoLogin'

/**
 * @param token - OIDCコールバックで受け取ったトークン
 * @param error - URLパラメータで受け取ったエラーメッセージ
 * @param redirectPath - ログイン成功後のリダイレクト先
 */
interface OneLoginTabProps {
  token?: string
  error?: string
  redirectPath?: string
}

/**
 * OneLoginタブコンポーネント
 * OneLoginを使用したSSO認証のUIとリダイレクト処理を提供
 * OIDCコールバック後の自動ログイン処理も担当
 *
 * 本番・dev のログインは dracaena が担うため、このタブはローカル専用。ローカルでも OIDC は疎通しない
 * （経緯と根拠は packages/backend/README.md の「OIDC 設定」）
 */
export function OneLoginTab({ token, error, redirectPath }: OneLoginTabProps) {
  const [loading, setLoading] = useState(false)

  // 自動ログイン処理（OIDCコールバック用）
  const { isAutoLoginInProgress, errorMessage: autoLoginError } = useAutoLogin({ token, redirectPath })

  // URLパラメータのエラーと自動ログインのエラーをマージ
  const errorMessage = error ?? autoLoginError

  /**
   * OneLoginログインボタンクリック処理
   * バックエンドのOIDC認証エンドポイントにリダイレクト
   */
  const handleOneLoginClick = () => {
    setLoading(true)

    // redirectパラメータがある場合はurlパラメータとして渡す
    const urlParam = redirectPath ? `&url=${encodeURIComponent(redirectPath)}` : ''

    // OIDCログインエンドポイントにリダイレクト
    // コールバック後、?token={token} でログインページに戻ってくる
    window.location.href = `/api/oidc/login?prompt=login${urlParam}`
  }

  if (isAutoLoginInProgress) {
    return (
      <div className='flex items-center justify-center py-6'>
        <AppLoadingSpinner size='default' text='ログイン中...' />
      </div>
    )
  }

  return (
    <div className='text-center py-6 space-y-8'>
      <AppButton onClick={handleOneLoginClick} disabled={loading}>
        <img src={OneLoginLogo} alt='OneLogin' className='h-11 w-11' />
        Oneloginでログイン
      </AppButton>
      {errorMessage && (
        <AppAlert type='error'>
          <div className='space-y-2'>
            <p>OneLoginでのログインに失敗しました</p>
            <p className='text-xs'>{errorMessage}</p>
          </div>
        </AppAlert>
      )}
      <AppAlert type='info'>案件ポータル利用には事前申請が必要です</AppAlert>
    </div>
  )
}
